import { IonIcon, IonLabel } from '@ionic/react';
import { chevronForwardOutline, brushOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from '../../components/globals/Modal';
import { UpdateUserFunc } from '../../hooks/WPHooks';
import { User, UserUpdate, WP_TagUser } from '../../model/models';
import { WP_Tag } from '../../model/tags/tags';
import { useLogger } from '../../services/LogService';
import { ModelsService } from '../../services/ModelsService';

interface InterestsChecked {
  tag: WP_Tag;
  isChecked: boolean;
  isVisible: boolean;
}

export const MyHobbies: React.FC<{
  user: User;
  update: UpdateUserFunc;
  hobbies: Array<WP_Tag>;
}> = ({ user, update, hobbies }) => {
  return (
    <Modal
      content={
        <MyHobbiesModaleContent user={user} update={update} hobbies={hobbies} />
      }
      ModalUrl={'/profile/hobbies'}
      backUrl={window.innerWidth > 768 ? '/profile/settings' : '/profile'}
      hideCloseBtn={false}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center text-black">
          <div className="flex w-8 h-8 mr-4 inset-4 justify-center items-center border border-transparent rounded-full text-white bg-primary ">
            <IonIcon icon={brushOutline} />
          </div>
          <IonLabel className="font-medium text-sm text-black">
            <FormattedMessage id="Centers of interest" />
          </IonLabel>
        </div>
        <IonIcon icon={chevronForwardOutline} />
      </div>
    </Modal>
  );
};

const MyHobbiesModaleContent: React.FC<{
  user: any;
  update: UpdateUserFunc;
  hobbies: Array<WP_Tag>;
}> = ({ user, update, hobbies }) => {
  const logger = useLogger('MyHobbiesModaleContent');

  const hoobiesToInterestsChecked = () => {
    const interestsChecked = hobbies.map((hobby: WP_Tag) => {
      const isChecked =
        user.acf.tags &&
        user.acf.tags.findIndex(
          (interest: WP_TagUser) => interest.term_id === hobby.id
        ) !== -1;
      return {
        isVisible: true,
        isChecked: isChecked,
        tag: hobby,
      };
    });

    return interestsChecked;
  };

  const [userHobbies, setUserHobbies] = useState<Array<InterestsChecked>>(
    hoobiesToInterestsChecked()
  );

  useEffect(() => {
    logger.info('useEffect() hobbies=', user.acf.tags);
    setUserHobbies(hoobiesToInterestsChecked());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hobbies]);

  const checkUserHobbies = (idInterests: number, checked: boolean) => {
    const newUserHobbies: InterestsChecked[] = JSON.parse(
      JSON.stringify(userHobbies)
    ).map((checkedHobby) => ({
      ...checkedHobby,
      isChecked:
        checkedHobby.tag.id === idInterests ? checked : checkedHobby.isChecked,
    }));

    setUserHobbies(newUserHobbies);

    return newUserHobbies;
  };

  const handleCheckboxChange = (event, idInterests: number) => {
    const copyUserHobbies = checkUserHobbies(idInterests, event.target.checked);

    logger.info('handleCheckboxChange() copyUserHobbies = ', copyUserHobbies);

    const data: UserUpdate = {
      acf: {
        tags: copyUserHobbies
          .filter((hobby) => hobby.isChecked === true)
          .map((hobby) => hobby.tag.id.toString()),
      },
    };

    update(data);
  };

  return (
    <div className="rounded-t-3xl bg-white modal-profile-content py-20 px-6 md:rounded-3xl">
      <div className="profile-header center flex flex-col items-center">
        <div className="flex w-14 h-14 inset-4 justify-center items-center border border-transparent rounded-full text-white bg-primary">
          <IonIcon
            className="w-7 h-7 text-white ios hydrated"
            icon={brushOutline}
            role="img"
          />
        </div>
        <h2 className="font-semibold text-xl mt-4 text-black">
          <FormattedMessage id="Centers of interest" />
        </h2>
      </div>
      <div className="mt-4">
        <ul>
          {userHobbies.map((hobby, index) => {
            const hobbyLabel = ModelsService.getTranslationFromTerm(
              hobby.tag,
              user.acf.locale
            );
            return (
              <li key={'hobbies_' + index} className="py-2">
                <div className="flex flex-row justify-between">
                  <span className="text-black">{hobbyLabel}</span>
                  <input
                    className="w-6 h-6 text-primary border-lightGrey appearance-none bg-white checked:bg-primary focus:ring-transparent  active:bg-primary rounded-full"
                    type="checkbox"
                    onChange={(event) =>
                      handleCheckboxChange(event, hobby.tag.id)
                    }
                    checked={hobby.isChecked}
                  />
                </div>
              </li>
            );
          })}
          {userHobbies.length === 0 && (
            <p className="text-center">
              <FormattedMessage id="No interests" />
            </p>
          )}
        </ul>
      </div>
    </div>
  );
};
